<div class="flex new-chat relative">
  <!-- Close button -->
  <button
    mat-icon-button
    mat-dialog-close
    aria-label="close"
    class="celo-dialog-close celo-dialog-close--floating"
  >
    <mat-icon>close</mat-icon>
  </button>

  <!-- Left side content -->
  <div class="chat" #chatWindow>
    <div #toolbar class="toolbar">
      <div class="title">
        {{ PAGE_META[page_type].title }}
      </div>

      <!-- Searchbar -->
      @if (PAGE_META[page_type].searchable) {
        <div class="my-input">
          <i class="material-icons-round mr-2">search</i>
          <input
            matInput
            placeholder="Search network"
            autocomplete="off"
            maxlength="30"
            [(ngModel)]="searchTerm"
            (keyup.enter)="searchNow($event.target.value)"
            (ngModelChange)="onSearchInputChanged($event)"
            keypress
            type="search"
          />
        </div>
      }
    </div>

    <!-- No internet state -->
    @if (!isOnline) {
      <div class="no-internet">
        <app-network-no-results></app-network-no-results>
        <div class="title">Get suggestions</div>
        <div class="subtitle">
          Connect to the internet to get suggestions from the network.
        </div>
      </div>
    } @else {
      <div
        [style.height.px]="chatWindow.offsetHeight - toolbar.offsetHeight"
        class="contents"
      >
        <div
          class="content"
          [ngClass]="{ hidden: !PAGE_META[page_type].directory }"
        >
          <div [ngClass]="{ hidden: searchMode }">
            <div class="section">
              @if (
                (myWorkspaces.length ||
                  partneredWorkspaces.length ||
                  hasConnections) &&
                !PAGE_META[page_type].hide_other_workspaces
              ) {
                <div class="header flex">
                  <div class="subtitle">My network</div>
                  @if (
                    myWorkspaces.length >
                      PAGE_META[page_type].max_visible_workspaces ||
                    partneredWorkspaces.length
                  ) {
                    <div
                      (click)="showAll = !showAll; raiseToggleEvents()"
                      class="celo-cursor-pointer show-more"
                    >
                      @if (!showAll) {
                        <span>Show more</span>
                      }
                      @if (showAll) {
                        <span>Show less</span>
                      }
                    </div>
                  }
                </div>
              }
              @if (!PAGE_META[page_type].hide_connections) {
                <div class="subcontent">
                  <app-contacts-expansion-panel
                    [uneditableContactIds]="uneditableContactIds"
                    [isAddingParticipants]="isAddingParticipants"
                    [userAccount]="userAccount"
                    [title]="'Connections'"
                    [hidden]="true"
                    [type]="'connections'"
                    [selectable]="PAGE_META[page_type].select_mode"
                    [selectedContactsMap]="selectedContacts.map"
                    (hasConnections)="hasConnections = true"
                    (contactClicked)="onClick($event)"
                    (contactSelected)="onSelect($event, true, 'connection')"
                    (remove)="onSelect($event, false, 'connection')"
                  ></app-contacts-expansion-panel>
                </div>
              }
              @if (myWorkspaces.length || partneredWorkspaces.length) {
                <div class="subcontent">
                  @for (
                    workspace of myWorkspaces;
                    track workspace;
                    let index = $index
                  ) {
                    <div>
                      @if (
                        index < PAGE_META[page_type].max_visible_workspaces ||
                        showAll
                      ) {
                        <div>
                          @if (
                            !workspaceIdToHide ||
                            workspaceIdToHide !== workspace.id
                          ) {
                            <app-contacts-expansion-panel
                              [attr.data-testid]="
                                page_type === 'new_broadcast'
                                  ? 'broadcast-workspace-contacts'
                                  : null
                              "
                              [companyInFocus]="workspacesMap[workspace.id]"
                              [companyInFocusId]="workspace.id"
                              [uneditableContactIds]="uneditableContactIds"
                              [isAddingParticipants]="isAddingParticipants"
                              [page_type]="page_type"
                              [userAccount]="userAccount"
                              [noTopMargin]="
                                PAGE_META[page_type].hide_other_workspaces
                              "
                              [disableExpansion]="
                                PAGE_META[page_type].hide_other_workspaces
                              "
                              [title]="workspace.name"
                              [hidden]="PAGE_META[page_type].hidden"
                              [type]="'workspace'"
                              [isWorkspaceVerified]="
                                myVerifiedWorkspaceIds.indexOf(workspace.id) !==
                                -1
                              "
                              [IncludeSelf]="!PAGE_META[page_type].hide_self"
                              [contactsToFilter]="contactsToFilter"
                              [workspaceId]="workspace.id"
                              [selectable]="PAGE_META[page_type].select_mode"
                              [selectedContactsMap]="selectedContacts.map"
                              (contactClicked)="onClick($event)"
                              (contactSelected)="
                                onSelect($event, true, 'colleague')
                              "
                              (remove)="onSelect($event, false, 'colleague')"
                            ></app-contacts-expansion-panel>
                          }
                        </div>
                      }
                    </div>
                  }
                  @if (showAll) {
                    <div>
                      @for (
                        workspace of partneredWorkspaces;
                        track workspace;
                        let index = $index
                      ) {
                        <div>
                          @if (
                            !workspaceIdToHide ||
                            workspaceIdToHide !== workspace.id
                          ) {
                            <app-contacts-expansion-panel
                              [companyInFocus]="workspacesMap[workspace.id]"
                              [companyInFocusId]="workspace.id"
                              [uneditableContactIds]="uneditableContactIds"
                              [isAddingParticipants]="isAddingParticipants"
                              [page_type]="page_type"
                              [userAccount]="userAccount"
                              [title]="workspace.name"
                              [hidden]="true"
                              [type]="'workspace'"
                              [isWorkspaceVerified]="
                                myVerifiedWorkspceIds.indexOf(workspace.id) !==
                                -1
                              "
                              [workspaceId]="workspace.id"
                              [selectable]="PAGE_META[page_type].select_mode"
                              [selectedContactsMap]="selectedContacts.map"
                              (contactClicked)="onClick($event)"
                              (contactSelected)="
                                onSelect($event, true, 'colleague')
                              "
                              (remove)="onSelect($event, false, 'colleague')"
                            ></app-contacts-expansion-panel>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
            @if (!PAGE_META[page_type].hide_suggestions) {
              <div class="section">
                @if (hasSuggestions) {
                  <div class="header header-suggested">
                    <div class="subtitle subtitle-suggested">Suggested</div>
                    <div class="subsubtitle">
                      Search to find other people on the network
                    </div>
                  </div>
                }
                <app-contacts-expansion-panel
                  [uneditableContactIds]="uneditableContactIds"
                  [isAddingParticipants]="isAddingParticipants"
                  [userAccount]="userAccount"
                  [title]="''"
                  [hidden]="false"
                  [type]="'suggestions'"
                  (hasSuggestions)="hasSuggestions = true"
                  [selectable]="PAGE_META[page_type].select_mode"
                  [selectedContactsMap]="selectedContacts.map"
                  (contactClicked)="onClick($event, 'suggestion')"
                  (contactSelected)="onSelect($event, true, 'suggestion')"
                  (remove)="onSelect($event, false, 'suggestion')"
                ></app-contacts-expansion-panel>
              </div>
            }
          </div>
          <!-- No suggestions state -->
          @if (
            !hasConnections &&
            !hasSuggestions &&
            !PAGE_META[page_type].hide_network &&
            isOnline
          ) {
            <div class="empty-state">
              @if (!discoverable) {
                <div>
                  <img src="../../../../assets/network-empty.png" alt="" />
                  <div class="title">Join the Celo community</div>
                  <div class="subtitle">
                    You can get suggestions and search the network by becoming
                    discoverable.
                  </div>
                  <a class="celo-link" [routerLink]="['/edit/privacy']"
                    ><button mat-button>Go to settings</button></a
                  >
                </div>
              }
              @if (discoverable) {
                <div>
                  <img src="../../../../assets/network-empty.png" alt="" />
                  <div class="title">Get suggestions</div>
                  <div class="subtitle">
                    Verify your identity or workspace to get suggestions and
                    search the network.
                  </div>
                  <a class="celo-link" (click)="verifyIdentity()"
                    ><button mat-button>
                      You can verify your identity using the mobile app.
                    </button></a
                  >
                </div>
              }
            </div>
          }
        </div>
        <!-- Search results -->
        @if (searchMode) {
          <div>
            <div class="section">
              <app-search-result
                [uneditableContactIds]="uneditableContactIds"
                [isAddingParticipants]="isAddingParticipants"
                [searchNow$]="searchNow$"
                [discoverable]="discoverable"
                [userAccount]="userAccount"
                [selectable]="PAGE_META[page_type].select_mode"
                [selectedContactsMap]="selectedContacts.map"
                [page_type]="page_type"
                [hideConnections]="PAGE_META[page_type].hide_connections"
                [hideNetwork]="PAGE_META[page_type].hide_network"
                [showUsersInWorkspaceIdOnly]="
                  page_type === 'new_broadcast' ? myWorkspaces[0].id : ''
                "
                [myWorkspacesAndPartnerWorkspaceIds]="
                  myWorkspacesAndPartnerWorkspaceIds
                "
                [excludeTeams]="page_type === 'new_broadcast'"
                (contactClick)="onSearchContactClick($event)"
                (contactSelect)="onSearchContactSelection($event)"
                (contactRemove)="onSelect($event, false)"
              ></app-search-result>
            </div>
          </div>
        }
        @if (page_type === "group_details" || page_type === "case_details") {
          <div class="content">
            <app-new-message-create
              [name]="name"
              (nameChange)="name = $event"
              (nameInvalid)="nameInvalid = $event"
              [patientData]="patientData"
              [type]="PAGE_META[page_type].type"
            ></app-new-message-create>
          </div>
        }
      </div>
    }

    <!-- Participant/user selection -->
  </div>

  <!-- Right side content -->
  <div
    [style.height.px]="chatWindow.offsetHeight"
    [ngClass]="{
      'side-displayed': PAGE_META[page_type].show_participants,
    }"
    class="side"
  >
    <div class="side-content">
      <!-- Conversation type selection -->
      @if (
        page_type !== "new_broadcast" &&
        !isAddingParticipants &&
        page_type === "new_chat"
      ) {
        <div class="new-button-bar">
          <div class="button group">
            <button mat-button (click)="newGroup()">
              <div>
                <span class="icon">
                  <mat-icon [svgIcon]="'new-group'"></mat-icon>
                </span>
                <span class="button-text">New Group</span>
              </div>
            </button>
          </div>
          <div class="button case">
            <button mat-button (click)="newCase()">
              <div>
                <span class="icon">
                  <mat-icon [svgIcon]="'new-case'"></mat-icon>
                </span>
                <span class="button-text">New Case</span>
              </div>
            </button>
          </div>
        </div>
      } @else {
        <!-- Selected contacts -->
        <div class="selected_contacts_box">
          <app-celo-selected-contacts
            [empty_message]="
              'Add ' +
              PAGE_META[page_type].item_salutation +
              's by selecting people from the list'
            "
            (searchChange)="search($event)"
            (changeSelection)="changeSelectedContacts($event)"
            [addContact$]="addContact$"
            [maxCapacity]="PAGE_META[page_type].max_capacity"
            [removeContact$]="removeContact$"
            [canRemoveContact$]="canRemoveContact$"
            [groupedContacts$]="groupedContacts$"
            [title]="
              PAGE_META[page_type].selectedContactsTitle
                ? PAGE_META[page_type].selectedContactsTitle
                : 'Participants'
            "
            [removable]="true"
            [salutation]="PAGE_META[page_type].item_salutation"
            [showAddParticipantsButton]="selectionDone"
            [selectedContactsLabelMap]="selectedContactsLabelMap"
            [replaceMyName]="
              userAccount.firstName + ' ' + userAccount.lastName + ' (You)'
            "
            [showMaxCount]="page_type === 'workspace_admin'"
            (editParticipants)="selectionDone = false"
            (capacityReached)="capacityReached()"
          >
          </app-celo-selected-contacts>
        </div>
        <!-- Flow navigation -->
        <div class="side-footer uppercase">
          <div class="button">
            @if (page_type === "new_case") {
              <button
                mat-button
                class="celo-primary-button"
                (click)="page_type = 'case_details'; exitSearchMode()"
              >
                Continue
              </button>
            }
            @if (page_type === "new_group") {
              <button
                mat-button
                class="celo-primary-button"
                (click)="page_type = 'group_details'; exitSearchMode()"
              >
                Continue
              </button>
            }
            @if (
              page_type === "case_details" || page_type === "group_details"
            ) {
              <button
                mat-button
                class="celo-primary-button"
                (click)="createConversation()"
                [disabled]="nameInvalid || loading"
              >
                <span
                  >Create new
                  <span>{{
                    page_type === "case_details" ? "case" : "group"
                  }}</span></span
                >
              </button>
            }
            @if (page_type === "new_broadcast") {
              <button
                mat-button
                class="celo-primary-button"
                (click)="createBroadcast()"
                [disabled]="
                  !selectedContacts.list || !selectedContacts.list.length
                "
              >
                <span>Create new broadcast</span>
              </button>
            }
            @if (page_type === "department_admin") {
              <button
                mat-button
                class="celo-primary-button"
                (click)="addUsers()"
                [disabled]="
                  !selectedContacts.list || !selectedContacts.list.length
                "
              >
                <span>Add</span>
              </button>
            }
            @if (page_type === "workspace_admin") {
              <button
                mat-button
                class="celo-primary-button"
                (click)="addUsers()"
                [disabled]="
                  !selectedContacts.list || !selectedContacts.list.length
                "
              >
                <span>Add to workspace</span>
              </button>
            }
            @if (isAddingParticipants) {
              <button
                mat-button
                class="celo-primary-button"
                (click)="onSave()"
                [disabled]="selectedContacts.list.length === 0"
              >
                <span>Save</span>
              </button>
            }
          </div>
          <div class="button">
            @if (page_type === "new_group" || page_type === "new_case") {
              <button
                mat-button
                (click)="backToNewChat()"
                class="celo-secondary-button"
              >
                Back
              </button>
            }
            @if (page_type === "case_details") {
              <button
                mat-button
                (click)="page_type = 'new_case'"
                class="celo-secondary-button"
              >
                Back
              </button>
            }
            @if (page_type === "group_details") {
              <button
                mat-button
                (click)="page_type = 'new_group'"
                class="celo-secondary-button"
              >
                Back
              </button>
            }
            @if (page_type === "new_broadcast") {
              <button [mat-dialog-close]="true" class="celo-secondary-button">
                Back
              </button>
            }
            @if (isAddingParticipants) {
              <button mat-button mat-dialog-close class="celo-secondary-button">
                Cancel
              </button>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>

@if (loading) {
  <div class="loading">
    <app-empty-state
      [spinner]="false"
      [animation]="true"
      [isLoading]="true"
      [message]="' '"
      [diameter]="30"
    ></app-empty-state>
  </div>
}
